import { IABExperiment } from '@cian/api-models/monolith-python/cian-api/site/v1/get-ab-experiments';

export const isFiltersDropdownSuburbanExperimentActive = (experiments: IABExperiment[] | undefined): boolean => {
  if (!experiments) {
    return false;
  }

  const experiment = experiments.find((exp: IABExperiment) => exp.name === 'audience_serp_filters_dropdown_suburban');

  return !!(experiment && experiment.abGroup === 1);
};
